import React from 'react';
import { useDispatch, useSelector } from "react-redux";

import { Box, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

import { getInventoryExportAction, getInventoryExportState } from "../../../../features/inventory/get_inventory_export";
import { getInventoryExportNotificationData } from "../../../../core/utils/notification_utils";
import useNotification from "../../../../core/hooks/use_notification";
import { CustomIconButton } from "../../../common/button";
import PageHeader from '../../../common/page_header';
import SectionPaper from '../../../common/section_paper';

const WarehouseReportsPage = () => {
    const { showNotification } = useNotification();
    const dispatch = useDispatch();

    const getInventoryExport = useSelector(getInventoryExportState);

    const onSubmit = () => {
        dispatch(getInventoryExportAction())
            .then(response => showNotification(getInventoryExportNotificationData(response)));
    };

    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3, mb: 4 } }>

            <PageHeader title="Raporty"/>

            <Box sx={ { maxWidth: 600 } }>
                <SectionPaper title="Zestawienie">
                    <Typography variant="body2" sx={ { mb: 3 } }>
                        Raport przedstawiający stany magazynowe wszystkich punktów sprzedaży sklepu.
                    </Typography>

                    <Box sx={ { display: 'flex', justifyContent: 'flex-end' } }>
                        <CustomIconButton
                            title="Pobierz raport"
                            isLoading={ getInventoryExport?.loading }
                            onClick={ onSubmit }
                            icon={ <DownloadIcon/> }
                        />
                    </Box>
                </SectionPaper>
            </Box>

        </Box>
    );
};

export default WarehouseReportsPage;